import { BoxProps, HStack, Text } from '@chakra-ui/react'

import { CountdownTimer } from '@wwt/ui/components'

interface ReasonPopupHeaderProps extends BoxProps {
	headerText: string
	onClose: () => void
	isFixed: boolean
}

export const ReasonPopupHeader = ({
	headerText,
	onClose,
	isFixed,
	...boxProps
}: ReasonPopupHeaderProps) => {
	return (
		<HStack
			p="0.75rem 1rem"
			w="100%"
			h={{ base: '3rem', md: '3.875rem' }}
			cursor="pointer"
			onClick={onClose}
			gap="1rem"
			alignItems="center"
			pr={{ base: 0, sm: '1rem' }}
			{...boxProps}
		>
			<CountdownTimer
				max={5}
				isStopped={isFixed}
			/>
			<Text>{headerText}</Text>
		</HStack>
	)
}
